export const IS_LOGGED = "is_logged";
export const USER_ID = "user_id";
export const THEME_COLOR = "dark-theme";
export const USER_SYSTEM_ROLE = "systemRole";
export const PHNO="phno";
export const AGENT_LOGIN="agent-login";
export const CLIENT_LOGIN="client-login";
export const CLIENT_PROFILE_CODE = "profile-code";
export const PROFILE_LOGIN="profile-login"
export const GOOGLE_USER="google-user"
export const LOGIN_BY="login-by"
export const USER_EMAIL = "USER_EMAIL";

